<template>
	<div class="RatingStars" :class="reverse ? 'RatingStars--reverse' : ''">
		<span class="is-visuallyHidden"> {{ $t('mediaRating.ratingsSingular') }} {{ rating }} </span>
		<div :class="'RatingStars-stars RatingStars-stars-' + rating">
			<CloIcon symbol="star" />
			<CloIcon symbol="star" />
			<CloIcon symbol="star" />
			<CloIcon symbol="star" />
			<CloIcon symbol="star" />
		</div>
		<span v-if="!minimal" class="RatingStars-count"
			>{{ correctedCount }}
			<template v-if="correctedCount === 1">
				{{ $t('mediaRating.ratingsSingular') }}
			</template>
			<template v-else>
				{{ $t('mediaRating.ratingsPlural') }}
			</template>
		</span>
	</div>
</template>

<script>
import CloIcon from '@/icons/CloIcon/CloIcon.vue';
export default {
	components: { CloIcon },
	props: {
		/**
		 * The number of stars.
		 */
		rating: {
			type: Number,
			default: null,
		},
		/**
		 * The number of rating submissions
		 */
		ratingCount: {
			type: Number,
			default: 0,
		},
		/**
		 * This determines whether or not the rating component should be exclude labels
		 */
		minimal: {
			type: Boolean,
			default: false,
		},
		reverse: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		// Immediately after the first rating, the count is cached and may still be 0
		// This correction displays 1 instead of 0
		correctedCount() {
			return this.ratingCount === 0 && this.rating ? 1 : this.ratingCount;
		},
	},
};
</script>

<style lang="scss">
.RatingStars {
	display: flex;
	align-items: center;
	--empty-color: #{subdueColor($color-text-muted)};
	--star-color: #{$brand-color-forest-green-9};
	--count-color: #{$color-text-muted};

	.RatingStars-stars {
		display: inline-flex;
		@include inline-xs;
		.Icon--star {
			fill: var(--empty-color);
			@include icon-sm;
		}
		.CheckboxGroup & {
			position: relative;
			bottom: 0.2rem;
			margin-right: 0.5rem;
		}
	}

	.RatingStars-count {
		color: var(--count-color);
		@include text(2);
	}

	.RatingStars-stars-1 {
		.Icon--star:nth-child(1) {
			fill: var(--star-color);
		}
	}

	.RatingStars-stars-2 {
		.Icon--star:nth-child(1),
		.Icon--star:nth-child(2) {
			fill: var(--star-color);
		}
	}

	.RatingStars-stars-3 {
		.Icon--star:nth-child(1),
		.Icon--star:nth-child(2),
		.Icon--star:nth-child(3) {
			fill: var(--star-color);
		}
	}

	.RatingStars-stars-4 {
		.Icon--star:nth-child(1),
		.Icon--star:nth-child(2),
		.Icon--star:nth-child(3),
		.Icon--star:nth-child(4) {
			fill: var(--star-color);
		}
	}

	.RatingStars-stars-5 {
		.Icon--star:nth-child(1),
		.Icon--star:nth-child(2),
		.Icon--star:nth-child(3),
		.Icon--star:nth-child(4),
		.Icon--star:nth-child(5) {
			fill: var(--star-color);
		}
	}

	.RatingStars-stars- {
		display: none;
	}
}

.RatingStars--reverse {
	--empty-color: #{subdueColor($color-text-muted-reverse)};
	--star-color: #{$brand-color-forest-green-dark-9};
	--count-color: #{$color-text-muted-reverse};
}
</style>
